export const getSectionName = (op) => {
  let section = 0;
  switch (op) {
    case "Ventas":
      section = 0;
      break;
    case "Almacén":
      section = 1;
      break;
    case "Clientes":
      section = 2;
      break;
    default:
      break;
  }
  return section;
};

export const fileSectionsList = [
  { id: "LH", text: "LÁMPARA DE HENDIDURA" },
  { id: "FO", text: "FONDO DE OJO" },
  { id: "TO", text: "TOPOGRAFÍA" },
  { id: "OP", text: "OPTOMETRÍA" },
  { id: "IN", text: "INFORMES" },
  { id: "VI", text: "VÍDEOS" },
];

export const mimeTypes = {
  pdf: "application/pdf",
  xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  xls: "application/vnd.ms-excel",
  docx: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  doc: "application/msword",
  pptx: "application/vnd.openxmlformats-officedocument.presentationml.presentation",
  ppt: "application/vnd.ms-powerpoint",
  jpg: "image/jpeg",
  jpeg: "image/jpeg",
  png: "image/png",
  svg: "image/svg+xml",
  csv: "text/csv",
  txt: "text/plain",
  json: "application/json",
  zip: "application/zip",
};
